import * as yup from "yup";

export const cadastroCondominioComplementarSchema = yup.object().shape({
  id_condominio_cond: yup.number(),
  malotes: yup.string().nullable(),
  data_inicio: yup.date().nullable().notRequired(),
  login_web: yup.string().nullable(),
  senha_web: yup.string().nullable(),
  obs: yup.string().default("").notRequired(),
  prazo_edital: yup.number().notRequired(),
  prazo_edital_dias_uteis: yup.boolean().default(false),
  cartorio: yup.string().nullable(),
});
